import { z } from 'zod';

export const TaskDescriptionSchema = z.object({
  task_description: z.string(),
});

export const DatasetNameSchema = z.object({
  dataset_name: z.string(),
});

export const DemoSchema = z.object({
  name: z.string(),
});
